/**
 * @generated SignedSource<<03b7e61e019a8d57d2ee34f0a46ada1c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchAtlasGoal_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultAtlasGoal";
  readonly description: string;
  readonly goal: {
    readonly description: string | null | undefined;
    readonly key: string;
  } | null | undefined;
  readonly iconUrl?: string | null | undefined;
  readonly id: string;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"goalTitleMetadata_AtlassianSearchPage">;
  readonly " $fragmentType": "searchAtlasGoal_AtlassianSearchPage";
};
export type searchAtlasGoal_AtlassianSearchPage$key = {
  readonly " $data"?: searchAtlasGoal_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchAtlasGoal_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "description"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    }
  ],
  "kind": "Fragment",
  "name": "searchAtlasGoal_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "goalTitleMetadata_AtlassianSearchPage"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "condition": "includeIconUrl",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    },
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        (v0/*: any*/)
      ]
    }
  ],
  "type": "SearchResultAtlasGoal"
};
})();

(node as any).hash = "5d37968657dd4ac5331c73def0a72966";

export default node;
